<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import popularSearchList from "./popular-search-list";
    export default {
    components: { Layout, PageHeader, popularSearchList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <popular-search-list/>
  </Layout>
</template>